import { FC, useState } from 'react';
import { Welcome } from 'components/Welcome/Welcome';
import { Layout } from 'components/Layout/Layout';
import { Questionnaire } from '../Questionnaire/Questionnaire';

import type { IQuestionnaireProps } from '../Questionnaire/models';

interface IQuizProps {
  onSaveSummary: IQuestionnaireProps['onSaveSummary'];
  sessionKey: string;
}

export const Quiz: FC<IQuizProps> = ({ onSaveSummary, sessionKey }) => {
  const [isQuizStarted, setIsQuizStarted] = useState(false);

  const onStartQuiz = () => {
    setIsQuizStarted(true);
  };

  const renderComponent = () => {
    if (isQuizStarted) {
      return <Questionnaire onSaveSummary={onSaveSummary} sessionKey={sessionKey}/>;
    }
    return <Welcome onStartQuiz={onStartQuiz} />;
  };

  return (
    <Layout isLeftLogoHidden={!isQuizStarted} isLogoAnimated={!isQuizStarted}>
      {renderComponent()}
    </Layout>
  );
};
